export const ActiveUseCaseBadge = ({ title }) => (
  <div className="flex items-center gap-2 bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm px-3.5 h-9 rounded-full border border-slate-200/60 dark:border-slate-600/50 shadow-sm max-w-[60vw] sm:max-w-none">
    <span className="w-2 h-2 rounded-full bg-[#36a852] animate-pulse flex-shrink-0" />
    <span className="text-xs font-semibold text-[#1d57a5] dark:text-[#4a8ce3] truncate">{title}</span>
  </div>
);
